import { render, staticRenderFns } from "./ChatBotSetup.vue?vue&type=template&id=05430e8c&scoped=true&"
import script from "./ChatBotSetup.vue?vue&type=script&lang=js&"
export * from "./ChatBotSetup.vue?vue&type=script&lang=js&"
import style0 from "./ChatBotSetup.vue?vue&type=style&index=0&id=05430e8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05430e8c",
  null
  
)

export default component.exports